module.exports = __webpack_public_path__ + "static/media/king.80ecf410.svg";